/* eslint-disable no-undef */
import React from 'react';
import CtaBoxView from '../views/CtaBoxView';
import { useHomeContext } from '../context';

export default function CTABoxController() {
  const {
    setShowSignInBox,
    setShowSignUpBox,
  } = useHomeContext();

  return (
    <CtaBoxView>
      <signin onClick={() => setShowSignInBox(true)} />


      <signup onClick={() => setShowSignUpBox(true)} />

    </CtaBoxView>
  );
}